<template>
  <div>
    <el-form :inline="true" :model="formInline" size="mini" class="user-search">
      <!--<el-form-item label="" prop="opeartorId">
        <el-select size="mini"
                   clearable
                   @change="selectOperator"
                   filterable
                   v-model="formInline.opeartorId"
                   placeholder="运营商"
        >
          <el-option label="全 部" value=""> </el-option>
          <el-option v-for="item in searchData.operators"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item prop="opeartorId">
        <el-cascader placeholder="运营商" size="mini" clearable
                     :options="operatorsTree"
                     ref="cascader"
                     :show-all-levels="false"
                     :props="{checkStrictly: true,expandTrigger: 'hover'}"
                     v-model="operatorIds"
                     @change="handChangeOperator"
                     filterable></el-cascader>
      </el-form-item>

    </el-form>

    <el-container>
      <el-main>
        <!--充电分析-->
        <el-row :gutter="44">
          <el-col :span="24">
            <div class="div_two div_margin">
              <h3 class="h5_style">充电分析</h3>
              <!--<div class="st-gbox" style="height: 20vh">
                <div class="div_style_one div_Orange">
                  <div class="fontStyle_three">
                    <div class="fontStyle_one">当日充电订单</div>
                    <div class="fontStyle_two">13</div>
                  </div>
                </div>
                <div class="div_style_one div_Orange">
                  <div class="fontStyle_three">
                    <div class="fontStyle_one">当日充电订单</div>
                    <div class="fontStyle_two">12</div>
                  </div>
                </div>
              </div>-->
              <div class="st-gbox">
                <div class="cavasbox" id="StationEchart"></div>
              </div>
            </div>
          </el-col>
        </el-row>

        <!--充电服务统计-->
        <el-row :gutter="14">
          <el-col :span="24">
            <div class="div_two div_margin">
              <h3 class="h5_style">充电服务统计</h3>
              <div class="st-gbox">
                <div class="cavasbox" id="chargeServiceTimes"></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--<el-row :gutter="14">
          <el-col :span="24">
            <div class="div_two div_margin">
              <h3 class="h5_style">电站分析</h3>
              <div class="st-gbox">
                <div class="cavasbox" id="PersonalEchart1"></div>
              </div>
            </div>
          </el-col>
        </el-row>-->
        <!--<el-row :gutter="14">
          <el-col :span="24">
            <div class="div_two div_margin">
              <h3 class="h5_style">会员分析</h3>
              <div class="st-gbox">
                <div class="cavasbox" id="customerFlow"></div>
              </div>
            </div>
          </el-col>
        </el-row>-->
      </el-main>
    </el-container>
  </div>
</template>

<script type="text/ecmascript-6">
  import Chart from 'echarts'
  import chargeApi from '@/module/dataCenter/api/businessCenter.js';
  import custApi from '@/module/dataCenter/api/customerAnalusis.js';
  import commonApi from '@/common/api/commonFromVuexApi.js'
  import comApi from '@/common/api/commonApi.js'

  export default {
    name: 'businessCenter2',
    data() {
      return {
        operatorsTree:[],
        operatorIds:[],
        formInline:{
          stationCode:'',
          opeartorId:''
        },
        searchData: {
          //站点集合
          stationData: [],
          operators:[]
        },
        chargeAnalyseStatistic:{
          xaxisData:[],
          yaxisData:{}
        },
        customerFlowData:{
          xaxisData:[],
          yaxisData:{}
        },

      }
    },
    // 导入组件
    components: {},
    // 创建完毕状态(里面是操作)
    created() {
      this.getChargeData();
      //this.getCustData();
      this.getOperators();
      this.getOperatorsTree()
    },
    // 挂载结束状态(里面是操作)
    watch: {
    },
    mounted() {
    },
    beforeUpdate() {
    },
    // 里面的函数只有调用才会执行
    methods: {
      //获取运营商树
      getOperatorsTree() {
        let params = JSON.stringify({});
        comApi.getOperatorsTree(params).then((res) => {
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(value){
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.formInline.opeartorId = operatorId
        let param = new Object();
        if(operatorId != ''){
          param.operatorId=operatorId;
        }
        this.getChargeData(JSON.stringify(param))
        this.$refs.cascader.dropDownVisible = false
      },
      selectOperator(val){
        let param = new Object();
        if(val != ''){
          param.operatorId=val;
        }
        this.getChargeData(JSON.stringify(param));
      },
      // 获取运营商
      getOperators() {
        commonApi.getOperators().then(res => {
          this.searchData.operators = res
        })
      },
      getCustData(parameter){
        console.log(parameter);
        this.loading = true;
        custApi.getAnalyseData(parameter).then((res) => {
          if(res){
            console.log("会员数据获取结果");
            console.log(res);
            this.customerFlowData = res;
            this.initCustomerChart();
          }
          // 加载结束
          this.loading = false
        }).then(() => {
          this.formInline.id = null
        }).catch(error => {
          this.loading = false
        })
      },
      getChargeData(parameter) {
        console.log(parameter);
        this.loading = true;
        chargeApi.getChargeAnalyseData(parameter).then((res) => {
          if(res){
            console.log("充电分析数据获取结果");
            console.log(res);
            this.chargeAnalyseStatistic = res;
            this.chargeAnalyseInitChart();
            this.chargeServiceTimesInitChart();
          }
          // 加载结束
          this.loading = false
        }).then(() => {
          this.formInline.id = null
        }).catch(error => {
          this.loading = false;
          this.$message({type: 'error', message: error})
        })
      },

      chargeAnalyseInitChart() {
        this.chart = Chart.init(document.getElementById("StationEchart"));
        this.chart.setOption({
          title: {
            //text: '充电分析'
            x: '20',
            top: '20',
            textStyle: {
              color: '#fff',
              fontSize: '22'
            },
            subtextStyle: {
              color: '#90979c',
              fontSize: '16'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['尖电量', '峰电量', '平电量', '谷电量'],
            top: '10%',
            left: 200,
            itemGap: 10,
            itemWidth: 15,
            itemHeight: 12
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          calculable: true,
          xAxis: {
            type: 'category',
            name:'时',
            axisTick: {
              show: false,
              length: 12,
              inside: true
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate:30
            },
            boundaryGap: false,
            data: this.chargeAnalyseStatistic.xaxisData
          },
          yAxis: {
            type: 'value',
            name: 'kW·h',

          },
          series: [
            {
              name: '尖电量',
              barWidth: 15,
              type: 'bar',
              data: this.chargeAnalyseStatistic.yaxisData.sharpElecData
            },
            {
              name: '峰电量',
              barWidth: 15,
              type: 'bar',
              data: this.chargeAnalyseStatistic.yaxisData.peakElecData
            },
            {
              name: '平电量',
              barWidth: 15,
              type: 'bar',
              data: this.chargeAnalyseStatistic.yaxisData.flatElecData
            },
            {
              name: '谷电量',
              barWidth: 15,
              type: 'bar',
              data: this.chargeAnalyseStatistic.yaxisData.valleyElecData
            }
          ]
        })
      },
      chargeServiceTimesInitChart() {
        this.chart = Chart.init(document.getElementById("chargeServiceTimes"));
        this.chart.setOption({
          title: {
            //text: '充电分析'
            x: '20',
            top: '20',
            textStyle: {
              color: '#fff',
              fontSize: '22'
            },
            subtextStyle: {
              color: '#90979c',
              fontSize: '16'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'line'
            }
          },
          legend: {
            data: ['充电次数','App','微信公众号','微信小程序','支付宝小程序','刷卡','互联互通'],
            top: '10%',
            left: 200,
            itemGap: 10,
            itemWidth: 15,
            itemHeight: 12
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          calculable: true,
          xAxis: {
            type: 'category',
            name:'时',
            axisTick: {
              show: false,
              length: 12,
              inside: true
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate:30
            },
            boundaryGap: false,
            data: this.chargeAnalyseStatistic.xaxisData
          },
          yAxis: {
            type: 'value',
            name: '次',
          },
          series: [
            {
              name: '充电次数',
              barWidth: 15,
              type: 'line',
              data: this.chargeAnalyseStatistic.yaxisData.chargeTimes
            },
            {
              name: 'App',
              barWidth: 15,
              type: 'line',
              data: this.chargeAnalyseStatistic.yaxisData.appData
            },{
              name: '微信公众号',
              barWidth: 15,
              type: 'line',
              data: this.chargeAnalyseStatistic.yaxisData.weixinData
            },{
              name: '微信小程序',
              barWidth: 15,
              type: 'line',
              data: this.chargeAnalyseStatistic.yaxisData.weixinXcxData
            },{
              name: '支付宝小程序',
              barWidth: 15,
              type: 'line',
              data: this.chargeAnalyseStatistic.yaxisData.aliXcxData
            },{
              name: '刷卡',
              barWidth: 15,
              type: 'line',
              data: this.chargeAnalyseStatistic.yaxisData.terminalData
            },{
              name: '互联互通',
              barWidth: 15,
              type: 'line',
              data: this.chargeAnalyseStatistic.yaxisData.cecData
            }
          ]
        })
      },
      initCustomerChart() {
        this.chart = Chart.init(document.getElementById("customerFlow"));
        this.chart.setOption({
          title: {
            //text: '充电分析'
            x: '20',
            top: '20',
            textStyle: {
              color: '#fff',
              fontSize: '22'
            },
            subtextStyle: {
              color: '#90979c',
              fontSize: '16'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: ['总客户数', '新增客户数','活跃客户数','流失客户数'],
            top: '10%',
            left: 200,
            itemGap: 10,
            itemWidth: 15,
            itemHeight: 12
          },

          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            show : true,
            feature : {
              dataView : {show: true, readOnly: false},
              magicType : {show: true, type: ['line', 'bar']},
              restore : {show: true},
              saveAsImage : {show: true}
            }
          },
          calculable: true,
          xAxis: {
            type: 'category',
            name:'日',
            axisTick: {
              show: false,
              length: 12,
              inside: true
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate:30
            },
            boundaryGap: false,
            data: this.customerFlowData.xaxisData
          },
          yAxis: {
            type: 'value',
            name: '个',
          },
          series: [
            {
              name: '总客户数',
              barWidth: 15,
              type: 'line',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: this.customerFlowData.yaxisData.totalData
            },
            {
              name: '新增客户数',
              barWidth: 15,
              type: 'bar',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: this.customerFlowData.yaxisData.growData
            },
            {
              name: '活跃客户数',
              barWidth: 15,
              type: 'bar',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: this.customerFlowData.yaxisData.activeData
            },{
              name: '流失客户数',
              barWidth: 15,
              type: 'bar',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: this.customerFlowData.yaxisData.reduceData
            }
          ]
        })
      },
    },

  }
</script>

<style scoped>
  .div_margin {
    margin-top: 20px;
    padding-bottom: 10px;
  }

  .div_two {
    background-color: white;
  }

  .h5_style {
    text-align: left;
    margin: 0px 0px 10px 5px;
    padding-top: 15px;
  }

  .div_style_one {
    float: left;
    width: 18%;
    height: 60px;
    margin: 0px 10px 10px 0px
  }

  .div_Orange {
    background-color: #ffbc2e;
  }

  .div_red {
    background-color: #FF6640;
  }

  .div_bule {
    background-color: #409EFF;
  }

  .div_green {
    background-color: #43c26e;
  }

  .fontStyle_three {
    margin: 10px 20px 0px 20px;
  }

  .fontStyle_one {
    color: white;
    font-size: small;
  }

  .fontStyle_two {
    color: white;
    font-size: 20px;
    margin-top: 5px;
  }

  .fontStyle_four {
    font-size: small;
  }

  .fontStyle_five {
    font-size: 20px;
    margin-top: 5px;
  }

  .el-header {
    color: #C0C4CC;
    text-align: center;
    line-height: 20px;
  }

  .el-main {
    background-color: #f0f9eb;
    color: #333;
    text-align: center;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .chargestate {
    padding-top: -120px;
  }

  .st-gbox {
    /*background-color: #fff;*/
    margin-top: 20px;
    border-radius: 5px;
    height: 45vh;
    box-sizing: border-box;
    padding: 10px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  /*.el-row {*/
  /*margin-bottom: 4px;*/
  /*&:last-child {*/
  /*margin-bottom: 0;*/
  /*}*/
  /*}*/
  .grid-content {
    border-radius: 2px;
    min-height: 28px;
    line-height: 28px;
    text-align: left;
    font-size: small;
    color: #606266;
    padding-left: 10px;
  }

  /deep/ .el-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/businessCenter/businessCenter2.vue